export * from './10_tyytl.component';